import { jsx } from 'react/jsx-runtime';
import { warnIfInvalidPeerDependency, resolveMaybeUrlArg } from '@uploadthing/shared';
import { version } from 'uploadthing/client';
import { p as peerDependencies, U as UploadButton } from './button-client-DaYiwH1a.js';
export { g as generateReactHelpers } from './button-client-DaYiwH1a.js';
import { U as UploadDropzone } from './dropzone-client-rGcERk9B.js';
export { u as useDropzone } from './dropzone-client-rGcERk9B.js';
import { U as Uploader } from './uploader-client-DffuKGf6.js';

const generateUploadButton = (opts)=>{
    warnIfInvalidPeerDependency("@uploadthing/react", peerDependencies.uploadthing, version);
    const url = resolveMaybeUrlArg(opts?.url);
    const fetch = opts?.fetch ?? globalThis.fetch;
    const TypedButton = (props)=>/*#__PURE__*/ jsx(UploadButton, {
            ...props,
            url: url,
            fetch: fetch
        });
    return TypedButton;
};
const generateUploadDropzone = (opts)=>{
    warnIfInvalidPeerDependency("@uploadthing/react", peerDependencies.uploadthing, version);
    const url = resolveMaybeUrlArg(opts?.url);
    const fetch = opts?.fetch ?? globalThis.fetch;
    const TypedDropzone = (props)=>/*#__PURE__*/ jsx(UploadDropzone, {
            ...props,
            url: url,
            fetch: fetch
        });
    return TypedDropzone;
};
const generateUploader = (opts)=>{
    warnIfInvalidPeerDependency("@uploadthing/react", peerDependencies.uploadthing, version);
    const url = resolveMaybeUrlArg(opts?.url);
    const fetch = opts?.fetch ?? globalThis.fetch;
    const TypedUploader = (props)=>/*#__PURE__*/ jsx(Uploader, {
            ...props,
            url: url,
            fetch: fetch
        });
    return TypedUploader;
};

export { UploadButton, UploadDropzone, Uploader, generateUploadButton, generateUploadDropzone, generateUploader };
